import React, { useContext, useState} from "react";
import AuthLayout from "../../components/layouts/AuthLayout";
import Input from "../../components/Inputs/Input";
import { useNavigate, Link } from "react-router-dom";
import {validateEmail,validatePassword} from  "../../utils/helper"
import axiosInstance from "../../utils/axiosInstance";
import { API_PATHS } from "../../utils/apiPaths";
import { UserContext } from "../../context/UserContext";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const {updateUser} = useContext(UserContext);    
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if(!validateEmail(email)){
      setError("entrez un mail valide.")
      return
    }

    if (!validatePassword(password)) {
      setError("au moins une lettre minuscule, une lettre majuscule, un chiffre, un caractère spécial et une longueur minimale de 8 caractères.")
      return;
    }

    setError("")
    //Login API Call
    try {
         const response = await axiosInstance.post(API_PATHS.AUTH.LOGIN, {
      email,
      password,
    });
        const {token,role} = response.data
        if (token){
          localStorage.setItem("token",token);
          updateUser(response.data)
          //redirection base sur le role
        navigate(role === "admin" ? "/admin/dashboard" : "/user/dashboard");
     }
          console.log(response.data)
    } catch (error) {
       if(error.response && error.response.data.message){
        setError(error.response.data.message)
       }else{
        setError("Les informations entrees sont invalide veillez ressayer !");
       }
    }
  };
  return (
    <AuthLayout>
      <div className="lg:w-[70%] h-3/4 md:h-full flex flex-col justify-center">
        <h3 className="text-xl font-semibold text-black">Bienvenue</h3>
        <p className="text-xs text-slate-700 mt-[5px] mb-6">
          Entrer vos informations de connexion
        </p>
        <form onSubmit={handleSubmit}>
          <Input
            value={email}
            onChange={({ target }) => setEmail(target.value)}
            label="email"
            placeholder="john@example.com"
            type="text"
          />
          <Input
            value={password}
            onChange={({ target }) => setPassword(target.value)}
            label="mot de passe"
            placeholder="minimum 8 carateres"
            type="password"
          />
          {error && <p className="text-red-500 text-xs pb-2.5 ">{error}</p>}
          <button type="submit" className="btn-primary disabled:opacity-50"  disabled={!email || !password}>
            se connecter
          </button>

          <p className="text-[13px] text-slate-800 mt-3">
            Vous n'avez pas de compte?{""}
            <Link className="font-bold text-blue-600 underline" to="/signup">s'enregistrer</Link>
          </p>
          <p className="text-[13px] text-slate-800 mt-3">
            Mot de passe oublier?{""}
            <Link className="font-bold text-blue-600 underline" to="/forgot">reinitialiser le mot de passe</Link>
          </p>
        </form>
      </div>
    </AuthLayout>
  );
};

export default Login;
